// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConcentratorSelected_container__j9OyD {
  animation: ConcentratorSelected_init__tm4YN 0.5s;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.ConcentratorSelected_container__j9OyD .ConcentratorSelected_header__Lz1W4 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}

.ConcentratorSelected_container__j9OyD .ConcentratorSelected_navigator__FplTp {
  width: 90%;
  display: flex;
  align-items: center;
}

.ConcentratorSelected_container__j9OyD .ConcentratorSelected_header__Lz1W4 .ConcentratorSelected_title__bFeDy {
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ConcentratorSelected_container__j9OyD .ConcentratorSelected_header__Lz1W4 .ConcentratorSelected_title__bFeDy p,
span {
  font-size: 1.5rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.ConcentratorSelected_container__j9OyD .ConcentratorSelected_header__Lz1W4 .ConcentratorSelected_title__bFeDy p {
  font-size: 1.5rem;
  margin-left: 10px;
  padding: 5px;
  border-radius: 10px;
  box-shadow: -5px 5px 15px -3px rgba(0, 0, 0, 0.111);
}

.ConcentratorSelected_tableContainer__SMjw2 {
  width: 90%;
}

.ConcentratorSelected_tableContainer__SMjw2 .ConcentratorSelected_table__7YvbW {
  margin-top: 10px;
  width: 100%;
  border-radius: 20px 20px 15px 15px;
  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.112);
}

.ConcentratorSelected_modalDiv__dgmuc {
  width: 90%;
  height: 100%;
  display: flex;
  align-items: center;
}

.ConcentratorSelected_modalDiv__dgmuc h1 {
  width: 100%;
  font-family: Roboto, sans-serif;
  font-size: 24px;
  font-weight: 300;
  text-align: center;
}

.ConcentratorSelected_addUserContainer__hYkZU {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
}

.ConcentratorSelected_emailAddUser__9bV-y {
  margin-top: 10px;
  font-size: 1.4em;
  font-weight: 400;
}

.ConcentratorSelected_nameAddUser__WgZ8K {
  margin-top: 30px;
  font-size: 1.5rem;
}

.ConcentratorSelected_end__nLyC9 {
  margin-top: 50px;
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
}

@keyframes ConcentratorSelected_init__tm4YN {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Concentrators/ConcentratorSelected/ConcentratorSelected.module.css"],"names":[],"mappings":"AAAA;EACE,gDAAoB;EACpB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 70px;\n}\n\n.container .navigator {\n  width: 90%;\n  display: flex;\n  align-items: center;\n}\n\n.container .header .title {\n  width: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .title p,\nspan {\n  font-size: 1.5rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .header .title p {\n  font-size: 1.5rem;\n  margin-left: 10px;\n  padding: 5px;\n  border-radius: 10px;\n  box-shadow: -5px 5px 15px -3px rgba(0, 0, 0, 0.111);\n}\n\n.tableContainer {\n  width: 90%;\n}\n\n.tableContainer .table {\n  margin-top: 10px;\n  width: 100%;\n  border-radius: 20px 20px 15px 15px;\n  box-shadow: 0px 0px 15px -3px rgba(0, 0, 0, 0.112);\n}\n\n.modalDiv {\n  width: 90%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.modalDiv h1 {\n  width: 100%;\n  font-family: Roboto, sans-serif;\n  font-size: 24px;\n  font-weight: 300;\n  text-align: center;\n}\n\n.addUserContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  font-weight: 700;\n}\n\n.emailAddUser {\n  margin-top: 10px;\n  font-size: 1.4em;\n  font-weight: 400;\n}\n\n.nameAddUser {\n  margin-top: 30px;\n  font-size: 1.5rem;\n}\n\n.end {\n  margin-top: 50px;\n  width: 100%;\n  height: 200px;\n  display: flex;\n  justify-content: center;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ConcentratorSelected_container__j9OyD`,
	"init": `ConcentratorSelected_init__tm4YN`,
	"header": `ConcentratorSelected_header__Lz1W4`,
	"navigator": `ConcentratorSelected_navigator__FplTp`,
	"title": `ConcentratorSelected_title__bFeDy`,
	"tableContainer": `ConcentratorSelected_tableContainer__SMjw2`,
	"table": `ConcentratorSelected_table__7YvbW`,
	"modalDiv": `ConcentratorSelected_modalDiv__dgmuc`,
	"addUserContainer": `ConcentratorSelected_addUserContainer__hYkZU`,
	"emailAddUser": `ConcentratorSelected_emailAddUser__9bV-y`,
	"nameAddUser": `ConcentratorSelected_nameAddUser__WgZ8K`,
	"end": `ConcentratorSelected_end__nLyC9`
};
export default ___CSS_LOADER_EXPORT___;
